import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {withRouter} from 'react-router-dom';
import ReactHighcharts from 'react-highcharts';
import ReactHighmaps from 'react-highcharts/ReactHighmaps';
import Boundary from '../Boundary';
import * as AdminActions from '../../store/actions/adminActions';
import SubjectEngagement from './SubjectEngagement';

class Countries extends Component {
    componentDidMount(){
        this.props.getCountries(1, this.props.user.id);
    }

    render(){
        return (
            <li className="dd-item dd3-item" data-id="13">
                <div className="dd-handle dd3-handle"></div>
                <div className="dd3-content">
                    <div className="row">
                        <div className="col-md-6">
                        
                        <div className="panel customPanel">
                            <div className="panel-heading border-bottom panel-heading-with-subtext">
                                <h3 className="panel-title">Sessions by Country</h3>
                            </div>
                            <div className="panel-body no-padding">

                                <div id="WorldMapChart" >
                                    <Boundary>
                                        {this.props.charts["countries"] ?
                                            
                                            <ReactHighmaps
                                                config={this.props.charts["countries"]}
                                                isPureConfig={true}
                                                neverReflow={true}
                                                ref="chart"
                                            />
                                            :
                                            null
                                        }
                                    </Boundary>
                                </div>
                                        
                            </div>
                            <div className="panel-footer">
                                <div className="w-200">
                                    <div className="form-select-overlay ">
                                        <select value={this.props.kpiLength} onChange={e => {
                                            e.preventDefault();
                                            this.props.getCountries(e.target.value, this.props.user.id);
                                        }} className="form-control" required="required">
                                            <option value={1}>Yesterday</option>
                                            <option value={2}>2 day</option>
                                            <option value={7}>1 Week</option>
                                            <option value={30}>1 Month</option>
                                            <option value={365}>1 Year</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>

                        <div className="col-sm-6">
                            <SubjectEngagement />
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

const mapStateToProps = state => ({
    ...state.auth,
    ...state.adminInfo
});

const mapDispatchToProps = dispatch => ({
    getCountries: (length, token) => {
        dispatch(AdminActions.getCountries(length, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Countries));


// WEBPACK FOOTER //
// ./src/components/AdminConsole/countries.js